<template>
  <div :class="preflxCls">
    <z-dialog :title="title" @close="closeDialog" @submit="submit">
      <!-- <div class="tab ">
        <Tabs value="1 mem-tabs">
          <TabPane label="灵感源" name="1"></TabPane>
          <TabPane label="产品" name="name2"></TabPane>
        </Tabs>
      </div> -->
      <div :class="preflxCls+'-search'">
        <Input
          v-model="filter.keyword"
          :maxlength="50"
          @on-enter="searchHandle"
          search
          placeholder="请输入搜索内容、关键字"
        >
          <Icon type="ios-search" slot="suffix" />
        </Input>
      </div>

      <div :class="preflxCls+'-list'">
        <div v-if="lists">
          <div
            v-if="lists.list.length > 0"
            :class=" item.disabled === 1? 'item-disabled' : 'item'"
            @click="choiced(item)"
            v-for="(item, index) in lists.list"
            :key="index"
          >
            <img v-if="tag==='product' && item.coverFile" :src="ossUrl+ item.coverFile.key" alt />
            <img
              v-if="tag==='favorites' && item.inspirationFile"
              :src="ossUrl+ item.inspirationFile.key"
              alt
            />
            <Icon
              type="md-checkmark-circle"
              class="choiced"
              v-if="choicedListsId.includes(item.id)"
            />
            <div class="lose" v-if="item.disabled === 1">产品失效</div>
            <!-- <div class="past" v-if="item.status === 0">临时单品</div> -->
          </div>
          <div v-if="(lists.list && lists.list.length == 0) || !lists">
            <z-empty txt="暂时还没有内容"></z-empty>
          </div>
        </div>
      </div>
      <z-page
        v-if="lists"
        :total="lists.total || 0"
        :pageSize="filter.pageSize"
        v-model="filter.pageNum"
      ></z-page>
    </z-dialog>
  </div>
</template>
<script>
const preflxCls = "zFavoritelog";
import ZPage from "../page/page";
import { findComponentDownward } from "../../utils/assist.js";
import ZDialog from "./dialog";
import ZEmpty from "../empty";
export default {
  name: "ZFavoritelog",
  provide() {
    return {
      app: this
    };
  },
  data() {
    return {
      preflxCls: preflxCls,
      diaologDom: null,
      choicedListsId: [],
      choicedLists: [],
      filter: {
        pageNum: 1,
        pageSize: 20,
        keyword: ""
      }
    };
  },
  props: {
    tag: {
      type: String,
      default: "product"
    },
    ossUrl: {
      type: String,
      default: ""
    },
    display: {
      type: Boolean,
      default: false
    },
    lists: {},
    loading: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "暂无标题"
    },
    width: {
      type: [Number, String],
      default: 360
    },
    btnTxt: {
      type: [Number, String],
      default: "确定"
    }
  },
  components: { ZDialog, ZPage, ZEmpty },

  methods: {
    submit() {
      if (this.choicedLists.length === 0) {
        this.$Message.warning("请选择要添加的产品");
        return false;
      }
      this.$emit("submitHandle", this.choicedLists);
    },
    searchHandle() {
      this.getLists();
    },
    // $emit
    getLists() {
      this.$emit("reqList", this.filter);
    },
    // 选择
    choiced(item) {
      if (item.disabled === 1) {
        return false;
      }
      let num = 0;
      this.tag === "product" ? (num = 9) : (num = 5);
      let _i = this.choicedListsId.indexOf(item.id);
      if (_i === -1 && this.choicedLists.length < num) {
        this.choicedListsId.push(item.id);
        this.choicedLists.push(item);
      }
      if (_i !== -1 && this.choicedLists.length <= num) {
        this.choicedListsId.splice(_i, 1);
        this.choicedLists.splice(_i, 1);
      }
      if (this.choicedLists.length >= num) {
        this.$Message.warning(`最多只能选择${num}个`);
        return false;
      }
    },

    closeDialog() {
      this.$emit("close");
    }
  },

  watch: {
    "filter.pageNum": function() {
      this.getLists();
    },
    display: function() {
      if (this.display) {
        this.diaologDom.op();
      } else {
        this.diaologDom.close();
        this.choicedLists = [];
        this.choicedListsId = [];
        this.filter.keyword = ''
      }
    }
  },

  mounted() {
    const Dialog = findComponentDownward(this, "ZDialog");
    if (Dialog) {
      this.diaologDom = Dialog;
    }
  }
};
</script>